<template>
  <div class="row">
    <div class="col-sm-7">
      <div class="order-number">
        Offerte #{{ internalReference }}

        <span class="order-saved">
          <font-awesome-icon icon="check" class="font-awesome-icon order-saved-icon"/>
          Offerte opgeslagen
        </span>
      </div>

      <div class="order-date">
        Offertedatum: {{ createdAt }}
      </div>
    </div>
    <div class="col-sm-6">
      <div class="float-right">
        <button @click="download" type="button" class="btn btn-outline-oldevuuren download-order btn-round w-100">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-down"/>
          Download offerte
          <font-awesome-icon class="font-awesome-icon" v-if="isDownloadingOrder" icon="spinner" spin/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { DOWNLOAD_ORDER } from '../../store/types'

  export default {
    props: ['order'],
    data() {
      return {}
    },
    computed: {
      isDownloadingOrder() {
        return this.$store.getters.isDownloadingOrder
      },
      createdAt() {
        return this.$store.getters.createdAt
      },
      internalReference() {
        return !this.$store.getters.internalReference ? '' : this.$store.getters.internalReference
      }
    },
    methods: {
      download() {
        this.$store.dispatch(DOWNLOAD_ORDER, this.internalReference)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
